exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".control-switch .input-switch:disabled ~ .symbol-switch .st1{fill:#d3edff}.control-switch .input-switch:disabled ~ .symbol-switch .st2{fill:#b1ddf8}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/settings/Containers/gdUnitControlPanel/modules/settings/toggleSwitch.scss
// module id = 451
// module chunks = 0 1